module.exports = __webpack_public_path__ + "3399d604b656023383db95baf7484d1e.png";